import type { ReactNode } from 'react';
import styles from './Notice.module.css';
import { Icon } from './Icon.js';
import { ICONS } from '../icons/index.js';

/**
 * **`Notice`**（§4.3 の 9 / D13 / D22）。
 *
 * ## 文言は固定。**変数を差し込まない**（§5.5）
 *
 * D13 は注意書きを **2 点だけ**と定めている。
 * **props で文言を受け取らない** — 受け取れるようにすると、
 * **3 点目が「一時的に」足される経路ができる**。
 *
 * ## 置き場所と大きさ
 *
 * §4.8:「免責は**入力欄の下に常設**（D13。**ページ内に 1 箇所だけ**）」。
 * **`Accordion` に入れない**（§5.3: **必須情報を畳まない**）。
 *
 * **`Banner` をやめた**（M16）。**囲みの面と 12px の内側余白 + 14px×1.7 の 2 行で
 * 約 72px を占めており、入力欄より目立っていた**（実機で
 * 「**注釈で小さい文字でいいはずなのにスペース取りすぎてる**」と読まれた）。
 *
 * **常設で、読み終えたあとも毎ターン視界に入り続けるもの**なので、
 * **1 行に畳んで地の面に置く**。**文言は 1 字も変えていない** —
 * 変えると D13 の 2 点が別のものになる。
 */
export const NOTICE_LINES: readonly string[] = [
  '答えは教えません。一緒に考えて、どこでつまずいているかを見つけます。',
  '生成AIの回答は 100% 正しいとは限りません。',
];

export function Notice(): ReactNode {
  return (
    <p className={styles['notice']}>
      <Icon svg={ICONS.information} size={16} />
      {NOTICE_LINES.map((line, i) => (
        <span key={line} className={styles['line']}>
          {/* **区切りは記号 1 つ**（改行しない。狭いときだけ折り返す） */}
          {i === 0 ? null : <span className={styles['sep']} aria-hidden="true" />}
          {line}
        </span>
      ))}
    </p>
  );
}
